import {Roles} from "@/utils/constants/common.constants.ts";
import {Push} from "notivue";

export interface IGetResult {
    messageType?: keyof Push,
    success?: boolean,
    message?: string,
    title?: string,
    data?: ApiPayload,
    redirectUrl?: string
}

export interface IUpdateProfileRequest extends /* @vue-ignore */ IUser {

}

export interface ILoginByCodeAndPassword extends /* @vue-ignore */ Pick<IUser, "code" | "password"> {
}

export enum PaymentStatus {
    PAID = "paid",
    REFUNDED = "refunded",
    CANCELED = "canceled"
}

export interface ITimestampsConfig {
    createdAt: Date | string;
    updatedAt?: Date | string;
}

export interface AGGridConfig {
    _changedCells?: Record<string, boolean>;
    _original?: any,
    isNew?: boolean
}

export interface Document extends /* @vue-ignore */ ITimestampsConfig {
    _id: string
}

export interface ICreatedBy {
    createdBy?: Partial<IUser>
}

export interface IAGRow extends /* @vue-ignore */ Document, AGGridConfig, ICreatedBy, Object {

}

export type ISchema = IAGRow;

export interface IUser extends /* @vue-ignore */ ISchema {
    _id: string,
    name: string;
    nickName?: string;
    code: string;
    email?: string;
    lastLogin: Date;
    status?: IAttendance['status'];
    createdBy: IUser;
    forceLogoutAt?: Date | undefined;
    role: Roles;
    provider?: Providers;
    avatar?: string;
    password?: string;
    groups?: {
        math?: IGroup | null,
        physics?: IGroup | null
    },
    isProfileCompleted: boolean;
    isVerified: boolean;
    classLevel?: ClassLevel | null,
}

export interface IGrade extends /* @vue-ignore */ ISchema {
    _id: string,
    subject: Subject | null,
    grade: number | null,
    name: string,
    maxGrade: number | null,
    student: IUser | null,
    classLevel: ClassLevel
}

export interface IPayment extends /* @vue-ignore */ ISchema {
    _id: string,
    student: IUser,
    amount: number,
    month: any,
    year: number,
    subject: Subject,
    addedBy: IUser,
    status: PaymentStatus,
    note?: string
}

export interface ILesson extends /* @vue-ignore */ ISchema {
    _id: string,
    title?: string,
    subject: Subject | null,
    classLevel: ClassLevel | null,
    attendance: IAttendance[],
    group: IGroup | null
}

export interface IAttendance extends /* @vue-ignore */ ISchema {
    _id: string,
    student: IUser,
    payments: IPayment[],
    status: AttendanceStatus,
    previousStatus: AttendanceStatus,
    note?: string
}

export interface IGroup extends /* @vue-ignore */ ISchema {
    name: string,
    subject: Subject,
    maxStudents: number,
    classLevel: ClassLevel
}

export interface IExam extends /* @vue-ignore */ ISchema {
    classLevel: ILesson['classLevel'],
    subject: ILesson['subject'],
    title: string,
    duration: number,
    scheduledAt?:Date,
    totalMarks: number,
    limit?: number,
    questions: IQuestion[],
    createdBy: IUser,
    status: ExamStatus
}

export interface IQuestionBase extends /* @vue-ignore */ ISchema {
    exam: IExam,
    text: string,
    marks: number,
}

export interface IMCQQuestion extends /* @vue-ignore */ IQuestionBase {
    correctAnswer: string,
    options: string[],
    type: QuestionType.MCQ
}

export interface ITrueFalseQQuestion extends /* @vue-ignore */ IQuestionBase {
    correctAnswer: boolean,
    type: QuestionType.TRUE_FALSE
}
export type IQuestion  = IMCQQuestion | ITrueFalseQQuestion

export interface IExamResult extends /* @vue-ignore */ ISchema {
    exam: IExam,
    student: IUser,
    selectedAnswers: IStudentAnswer[],
    totalMarksAwarded: number,
    completedAt: Date
}

export interface IStudentAnswer {
    question: IQuestion,
    selectedAnswer: IQuestion['correctAnswer'] | undefined,
    marksAwarded: number
}

export enum QuestionType {
    MCQ = "MCQ",
    TRUE_FALSE = "TRUE_FALSE"
}

export enum ExamStatus {
    DRAFT = "draft",
    PUBLISHED = "published",
    CLOSED = "closed"
}

export interface ApiPayload {
    phoneNumber?: string,
    user?: IUser,
    completePhoneNumberRegistrationDetailsToken?: string,
    resetPasswordToken?: string,
    function?: "initUser",
    message?: string,
    students?: IUser[],
    studentGrades?: IGrade[] | null,
    timestamp?: number,
    signature?: string,
    apiKey?: string,
    cloudName?: string,
    lessons?: ILesson[]
    lesson?: ILesson,
    lessonsForStudent?: Omit<ILesson, "attendance">[] | null,
    grades?: IGrade[],
    studentPayments?: IPayment[] | null
    payments?: IPayment[] | null,
    data?: any,
    forceUserToLogoutOut?: boolean
}

export enum Providers {
    Local = "local", Google = "google", Admin = "admin"
}

export enum AttendanceStatus {
    Present = "حاضر",
    Absent = "غايب",
    Late = "متأخر",
    Excused = "معذور",
    Initial = "لا يوجد",
    WrongGroup = "حاضر في مجموعة أخرى",
}

export interface ViewAllStudentsResponse {

}

export enum ClassLevel {
    FirstSecondary = "الصف الأول الثانوي",
    SecondSecondary = "الصف الثاني الثانوي",
    ThirdSecondary = "الصف الثالث الثانوي"
}

export enum Subject {
    Math = "الرياضيات",
    Physics = "الفيزياء"
}

export interface ISubmitGradeRequest extends /* @vue-ignore */ IGrade {
}

export interface ICreateLessonRequest extends /* @vue-ignore */ Omit<Omit<ILesson, keyof ITimestampsConfig>, "_id" | "attendance"> {
}

export type ICreatePaymentRequest = Omit<IPayment, "addedBy">


export interface ICreateGroupRequest {
}

export interface ICreateExamRequest extends /* @vue-ignore */ IExam {
}

export interface IGetStudentExamsSummary {
    exams?: IExam[],
    examsResult?: IExamResult[]
}

export interface ISubmitExamAnswersRequest {
    selectedAnswers: IStudentAnswer[],
    examResultId: string
}


export interface IAddAttendanceRequest {
    student: Pick<IUser, "_id" | "name" | "groups">,
    status?: `${AttendanceStatus}`
    lessonId: string,
}

export interface IDeleteAttendanceRequest {
    attendanceId: string
    lessonId: string
}

export interface IUpdateStudentRequest extends /* @vue-ignore */ Partial<IUser> {
    groups: IUser['groups']
}

export interface ICreateStudentRequest extends /* @vue-ignore */ Pick<IUser, "name" | "classLevel" | "isProfileCompleted" | "groups" | "password"> {
}

export type QueryFilter<T> = {
    filter?: Partial<T>,
    search?: string,
    limit?: number,
    page?: number
}

